import { Condition } from '@upstart/harmony/lib/constants';

export const validateAprConfig = (aprConfig, errors) => {
  [Condition.NEW].forEach((condition) => {
    const config = (aprConfig || {})[condition];
    if (!config) {
      return;
    }
    const { creditTiers } = config;
    if (!creditTiers) {
      return;
    }
    const aprConfigErrors = errors[condition];
    if (creditTiers.poor.low >= creditTiers.poor.high)
      aprConfigErrors.creditTiers.poor.high.addError(
        'Poor High should be greater than Below Average Low',
      );
    if (creditTiers.average.low <= creditTiers.poor.high)
      aprConfigErrors.creditTiers.average.low.addError(
        'Average High should be greater than Below Average High',
      );
    if (creditTiers.average.low >= creditTiers.average.high)
      aprConfigErrors.creditTiers.average.high.addError(
        'Average High should be greater than Average Low',
      );
    if (creditTiers.good.low <= creditTiers.average.high)
      aprConfigErrors.creditTiers.good.low.addError(
        'Good Low should be greater than Average High',
      );
    if (creditTiers.good.low >= creditTiers.good.high)
      aprConfigErrors.creditTiers.good.high.addError(
        'Good High should be greater than Good Low',
      );
    if (creditTiers.excellent.low <= creditTiers.good.high)
      aprConfigErrors.creditTiers.excellent.low.addError(
        'Excellent Low should be greater than Good High',
      );
    if (creditTiers.excellent.low >= creditTiers.excellent.high)
      aprConfigErrors.creditTiers.excellent.high.addError(
        'Excellent High should be greater than Excellent Low',
      );
  });
};
